(() => {

    // Block Name
    const blockName = 'visitgzm-mapa';

    // letiables
    let method = 'front';
    if (document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin')) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined) block = block[0].querySelector(`.block-${blockName}`);
        if (block === false || block === null) return;

        var $ = jQuery.noConflict();

        $(document).ready(function () {
            pageHeaderSpacer();
        });
        $(window).on('resize', function () {
            pageHeaderSpacer();
        });

        function pageHeaderSpacer() {
            const pageheaderHeight = $('.page-header').length ? $('.page-header').outerHeight() : 0;
            const infobarHeight = $('.c-infobar').length ? $('.c-infobar').outerHeight() : 0;
            const breadcrumbsHeight = ('.breadcrumbs').length ? $('.breadcrumbs').outerHeight() : 0;

            // const blockMapFullHeight = pageheaderHeight + infobarHeight + breadcrumbsHeight;
            const blockMapFullHeight = pageheaderHeight + infobarHeight;


            $('.js-height-sidebar, .js-height-view').css('height', 'calc(100vh - ' + blockMapFullHeight + 'px)');

            // const blockMapFullHeightHalf = blockMapFullHeight / 2;
            // if ($(window).outerWidth() >= 768) {
            //     $('.js-height-sidebar, .js-height-view').css('height', 'calc(100vh - ' + blockMapFullHeight + 'px)');
            // } else {
            //     $('.js-height-sidebar').css('height', 'calc(50vh - ' + blockMapFullHeightHalf + 'px)');
            //     $('.js-height-view').css('height', 'calc(50vh - ' + blockMapFullHeightHalf + 'px)');
            // }
        }


        // Block Code Here
        let activeLayers = new Map();
        let currentScroll = 0;


        let selectedCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active') ? block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category') : '';
        let selectedSubCategory = block.querySelector('[data-category-subcategories="'+selectedCategory+'"] .block-visitgzm-mapa__subcategoryBtn--active') ? block.querySelector('[data-category-subcategories="'+selectedCategory+'"] .block-visitgzm-mapa__subcategoryBtn--active').getAttribute('data-subcategory') : '';

        let markersData = block.id.replaceAll('-', '') + '_markers';
        let borderData = block.id.replaceAll('-', '') + '_border';
        let voivodeshipsData = block.id.replaceAll('-', '') + '_voivodeships';
        let regionsData = block.id.replaceAll('-', '') + '_regions';
        let styleData = block.id.replaceAll('-', '') + '_style';
        let mapBackgrounds = block.id.replaceAll('-', '') + '_mapsbackgrounds';

        let timer;

        let highlightPopPark;
        let activeLAyer = '';
        let currentCategory = document.querySelector('.block-visitgzm-mapa__categoryBtn--active') ? document.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category') : '';

        let highlightedMarker = null;


        markersData = window[markersData];
        borderData = window[borderData];
        voivodeshipsData = window[voivodeshipsData];
        regionsData = window[regionsData];
        styleData = window[styleData];
        mapBackgrounds = window[mapBackgrounds];
        console.log(mapBackgrounds);
        // mapBackgrounds = new Map(Object.entries(mapBackgrounds));


        // console.log(styleData);
        // console.log(styleData);
        if (!markersData) {
            return;
        }

        // Attribution
        let mbAttr = 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
        let mbUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw';

        // Map layers
        let CartoClassic = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
            attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a>'
        });
        let osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
        let satellite = L.tileLayer(mbUrl, {
            id: 'mapbox/satellite-v9',
            tileSize: 512,
            zoomOffset: -1,
            attribution: mbAttr
        });

        let CartoDb = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
            attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a>',
            //	className: 'carto',
            subdomains: 'abcd'
        });

        let GoogleSatellite = L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            // maxZoom: 16,
        });


        // for (const [key, value] of Object.entries(mapBackgrounds)) {
        //     console.log(`${key}: ${value}`);
        // }

        // Generate map
        let startZoom = 10;
        if (window.matchMedia('only screen and (max-width: 768px)').matches) {
            startZoom = 9;
        }
        let curentMapBackground = getCurentMapBackground();

        var map = L.map('mapVisitGZM', {
            center: [50.316735, 18.93359],
            zoom: startZoom,
            minZoom: 9,
            maxZoom: 17,
            layers: (curentMapBackground) ? [curentMapBackground] : '',
            maxBounds: [
                [51.5, 16.00],
                [49.0, 22.00]
            ],
        });


        let ovlPane = map.createPane('ovl');
        let shadowPane = map.createPane('shadowx');
        let woj = map.createPane('woj');
        // let waters = map.createPane('waters');
        let wms = map.createPane('wms');
        // waters.style.zIndex = 403;
        woj.style.zIndex = 390;
        wms.style.zIndex = 405;
        ovlPane.style.zIndex = 410;
        shadowPane.style.zIndex = 415;


        let shadow = L.geoJSON(borderData, {
            style: {
                fillOpacity: 1.0,
                fillColor: 'white',
                "weight": 0,
                clickable: false,
                interactive: false
            },
            className: 'granica_class',
            pane: 'shadowx',
            smoothFactor: 0.01
        }).addTo(map);


        let wojThick = L.geoJson(voivodeshipsData, {
            style: function () {
                return {
                    weight: 6,
                    opacity: 0.15,
                    color: '#bb57ff',
                    dashArray: '',
                    fillColor: 'rgb(32, 43, 79)',
                    fillOpacity: 0,
                    smoothFactor: 0.01,
                    clickable: false,
                    interactive: false
                }
            },
            className: 'b_woj0',
            pane: 'woj'
        }).addTo(map);

        let wojThin = L.geoJson(voivodeshipsData, {
            style: function () {
                return {
                    weight: 1.0,
                    opacity: 1,
                    color: '#777',
                    dashArray: '3 4',
                    fillColor: 'rgb(32, 43, 79)',
                    fillOpacity: 0,
                    smoothFactor: 0.01,
                    lineCap: 'square',
                    clickable: false,
                    interactive: false
                }
            },
            className: 'b_woj1',
            pane: 'woj'
        }).addTo(map);

        let gzm = L.geoJSON(regionsData, {
            style: function () {
                return {
                    opacity: 1,
                    color: "#000",
                    weight: 1.2,
                    dashArray: '3',
                    fillOpacity: 0,
                    smoothFactor: 0.05,
                    clickable: false,
                    interactive: false
                }
            },
            pane: 'ovl'
        }).addTo(map);

        // SHADOW xD
        let svg = shadowPane.firstChild;
        svgFilter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        svgBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
        svgComposite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
        svgOffset = document.createElementNS('http://www.w3.org/2000/svg', 'feOffset');
        svgTransfer = document.createElementNS('http://www.w3.org/2000/svg', 'feComponentTransfer');
        svgFuncA = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncA');
        svgMerge = document.createElementNS('http://www.w3.org/2000/svg', 'feMerge');
        svgMergeNode0 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        svgMergeNode1 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        svgFilter.setAttribute('id', 'dropshadow');
        svgBlur.setAttribute('stdDeviation', 10);
        svgBlur.setAttribute('in', 'SourceAlpha');
        svgOffset.setAttribute('result', 'offsetblur');
        svgOffset.setAttribute('dx', '0');
        svgOffset.setAttribute('dy', '0');
        svgFuncA.setAttribute('type', 'linear');
        svgFuncA.setAttribute('slope', '0.6');
        svgMergeNode1.setAttribute('in', 'SourceGraphic');
        svgComposite.setAttribute('operator', 'out');
        svgComposite.setAttribute('in2', 'SourceGraphic');
        svgFilter.appendChild(svgBlur);
        svgFilter.appendChild(svgOffset);
        svgTransfer.appendChild(svgFuncA);
        svgFilter.appendChild(svgTransfer);
        svgFilter.appendChild(svgMerge);
        svgMerge.appendChild(svgMergeNode0);
        svgMerge.appendChild(svgMergeNode1);
        svgFilter.appendChild(svgComposite);
        svg.appendChild(svgFilter);
        document.querySelector(".leaflet-shadowx-pane svg > g path").setAttribute("filter", "url(#dropshadow)");
        map.addLayer(gzm);


        let categoryLayers = {};
        let allGeoJsons = [];
        console.log(markersData);
        console.log(typeof markersData);
        for (const [categoryKey, categoryValue] of Object.entries(markersData)) {
            // categoryLayers[categoryKey] = {};
            for (const [subCategoryKey, subCategoryValue] of Object.entries(categoryValue)) {
                // console.log(categoryValue);
                // categoryLayers[categoryKey][subCategoryKey] = L.layerGroup();
                for (const [objectKey, objectValue] of Object.entries(subCategoryValue)) {
                    allGeoJsons.push(JSON.parse(objectValue.coordinates));
                    // categoryLayers[categoryKey][subCategoryKey].addLayer(L.geoJSON(JSON.parse(objectValue.coordinates)))
                    // for (const [key, value] of Object.entries(objectValue)) {
                    //     console.log(JSON.parse(objectValue.coordinates));
                    // }
                }
                // categoryLayers[categoryKey][subCategoryKey].addTo(map);
            }
        }
        let myIcon = L.divIcon({
            iconSize: new L.Point(25, 25),
            className: 'my-div-icon',
            html: '<span>o</span>'
        });

        // let IconStyleTwo = L.divIcon({
        //     iconSize: new L.Point(40, 40),
        //     iconAnchor: new L.Point(20, 20),
        //     className: 'visitgzm-marker visitgzm-marker--highlighted',
        //     html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + '" ><img src="' + iconUrl + '" /></span>'
        // });

        // console.log(allGeoJsons);
        let geoJsonLayer = [];
        allGeoJsons.forEach((element) => {
            geoJsonLayer.push(L.geoJSON(element, {
                onEachFeature: onEachMarker,
                filter: function (geoJsonFeature) {
                    return (geoJsonFeature.properties['category'] === currentCategory);
                },
                pointToLayer: function (geoJsonFeature, latlng) {
                    return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                },
                style: getStyle
            }).addTo(map));
        });
        // console.log(allGeoJsons);
        // console.log(geoJsonLayer);

        block.querySelectorAll('[data-object-category]').forEach((element) => {
            if (element.getAttribute('data-object-category') != currentCategory) {
                // console.log(element);
                element.classList.add('visitObject--hide');
            }
        });

        // updateLayer(['gzm:wody|waters'], true);
        updateLayer(['gzm:Tereny_gm_labels|woj'], true);
        pageHeaderSpacer();



        function onEachMarker(geoJsonFeature, layer) {
            // console.log('onEachMarker');

            layer.on({
                mouseout: function (e) {
                    if (typeof layer.closePopup == 'function') {
                        layer.closePopup();
                    } else {
                        layer.eachLayer(function (geoJsonFeature) {
                            geoJsonFeature.closePopup()
                        });
                    }
                },
                mouseover: highlightFeaturePark,
                click: clickMarker
            });
            
            let filtry = '';

            for (const [key, value] of Object.entries(geoJsonFeature.properties.filtres)) {
                if( value !== ''){
                    filtry += '<div class="visit-filter visit-filter--sm">'+value+'</div>';
                }
            }
              
            let secondarycolor = '--secondaryColor: ' + styleData[geoJsonFeature.properties['subcategory']]['secondaryColor'] + '; ';

            let popupContent =
                '<div class="frame" style="'+secondarycolor+'">' +
                (geoJsonFeature.properties.thumbnail !== '' ? '<img class="frame__thumb" src="' + geoJsonFeature.properties.thumbnail + '" >' : '') +
                    '<div class="frame__content">' +
                        '<div class="frame__title">' + geoJsonFeature.properties.title + '</div>' +
                        '<div class="frame__excerpt text-muted">' + geoJsonFeature.properties.subcategoryName + '</div>' +
                        // '<div class="frame__address">' + geoJsonFeature.properties.address + '</div>' +
                        (geoJsonFeature.properties.address !== '' ? '<div class="frame__address">' + geoJsonFeature.properties.address + '</div>' : '') +
                        (geoJsonFeature.properties.description !== '' ? '<div class="frame__text">' + geoJsonFeature.properties.description + '</div>' : '') +
                        // '<div class="frame__text">' + geoJsonFeature.properties.description + '</div>' +
                        (filtry !== '' ? '<div class="frame__filters">'+filtry+'</div>' : '') +
                    '</div>' +
                '</div>';

            let customOptions = {
                'maxHeight': '450',
                'className': 'visitgzmTooltip'
            };
            layer.bindPopup(popupContent, customOptions);
        }

        function clickMarker(e) {
            // console.log(e.target.feature);
            let iconUrl;
            let primaryColor;
            let secondaryColor;
            let primaryColorActive;
            let secondaryColorActive;
            

            // console.log( e.target.feature.properties.id );
            if (highlightedMarker !== null) {

                iconUrl = styleData[highlightedMarker.feature.properties['subcategory']]['point']['icon'];
                primaryColor = '--primarycolor: ' + styleData[highlightedMarker.feature.properties['subcategory']]['primaryColor'] + '; ';
                secondaryColor = '--secondarycolor: ' + styleData[highlightedMarker.feature.properties['subcategory']]['secondaryColor'] + '; ';
                primaryColorActive = '--primarycoloractive: ' + styleData[highlightedMarker.feature.properties['subcategory']]['primaryColorActive'] + '; ';
                secondaryColorActive = '--secondarycoloractive: ' + styleData[highlightedMarker.feature.properties['subcategory']]['secondaryColorActive'] + '; ';
            
                highlightedMarker.setIcon(
                    L.divIcon({
                        iconSize: new L.Point(26, 26),
                        iconAnchor: new L.Point(13, 13),
                        className: 'visitgzm-marker',
                        html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + '" ><img src="' + iconUrl + '" /></span>'
                    })
                );
                highlightedMarker = null;
            }
            iconUrl = styleData[e.target.feature.properties['subcategory']]['point']['icon'];
            primaryColor = '--primarycolor: ' + styleData[e.target.feature.properties['subcategory']]['primaryColor'] + '; ';
            secondaryColor = '--secondarycolor: ' + styleData[e.target.feature.properties['subcategory']]['secondaryColor'] + '; ';
            primaryColorActive = '--primarycoloractive: ' + styleData[e.target.feature.properties['subcategory']]['primaryColorActive'] + '; ';
            secondaryColorActive = '--secondarycoloractive: ' + styleData[e.target.feature.properties['subcategory']]['secondaryColorActive'] + '; ';
            
            // console.log(e.target.feature.properties.id);
            if(e.target.feature.properties.type == 'point'){

                e.target.setIcon(
                    L.divIcon({
                        iconSize: new L.Point(40, 40),
                        iconAnchor: new L.Point(20, 20),
                        className: 'visitgzm-marker visitgzm-marker--highlighted',
                        html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + '" ><img src="' + iconUrl + '" /></span>'
                    })
                );
                highlightedMarker = e.target;
            }

            block.querySelectorAll('.c-visit-details--show').forEach((el) => {
                el.classList.remove('c-visit-details--show');
            });
            if (block.querySelector('.visitTab--open')) {
                block.querySelector('.visitTab--open').classList.remove('visitTab--open');
            }


            block.querySelector('[data-details-id="' + e.target.feature.properties.id + '"]').classList.add('c-visit-details--show');
            block.querySelector('[data-tab="details"]').classList.add('visitTab--open');

            block.querySelector('.block-visitgzm-mapa__sidebar .visitSidebar__inner').scrollTop = 0;

            if(window.innerWidth < 768){
                block.querySelector('.block-visitgzm-mapa__sidebar').classList.add('active');
            }

            let currentCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
            let url = new URL(location.href);
            let params = new URLSearchParams(url.search);
            params.set("category", currentCategory);
            params.set("object", e.target.feature.properties.id);
            history.replaceState(
                null, '', location.origin + location.pathname  + '?' + params.toString()
            );
            
        }

        /**
         * Function open popup when marker hovered
         * @param {event} e
         */
        function highlightFeaturePark(e) {
            highlightPopPark = e.target;
            highlightPopPark.openPopup();
        }

        function getPoint(geoJsonFeature) {
            // console.log(geoJsonFeature);
            let iconUrl = styleData[geoJsonFeature.properties['subcategory']]['point']['icon'];
            let primaryColor = '--primarycolor: ' + styleData[geoJsonFeature.properties['subcategory']]['primaryColor'] + '; ';
            let secondaryColor = '--secondarycolor: ' + styleData[geoJsonFeature.properties['subcategory']]['secondaryColor'] + '; ';
            let primaryColorActive = '--primarycoloractive: ' + styleData[geoJsonFeature.properties['subcategory']]['primaryColorActive'] + '; ';
            let secondaryColorActive = '--secondarycoloractive: ' + styleData[geoJsonFeature.properties['subcategory']]['secondaryColorActive'] + '; ';
            return L.divIcon({
                iconSize: new L.Point(26, 26),
                iconAnchor: new L.Point(13, 13),
                className: 'visitgzm-marker',
                html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + '" ><img src="' + iconUrl + '" /></span>'
            });
        }

        function getStyle(geoJsonFeature) {
            console.log( geoJsonFeature.properties['type'] );
            console.log( geoJsonFeature.properties['subcategory'] );
            console.log( styleData[geoJsonFeature.properties['subcategory']][geoJsonFeature.properties['type']] );
            return styleData[geoJsonFeature.properties['subcategory']][geoJsonFeature.properties['type']];
        }

        function filterMarkersBySubcategory(event) {

            let category = event.target.getAttribute('data-parent');
            let subCategory = event.target.getAttribute('data-subcategory');

            if (subCategory == 'all') {

                document.querySelectorAll('.block-visitgzm-mapa__subcategoryBtn--active').forEach(activeSubCategory => {
                    activeSubCategory.classList.remove('block-visitgzm-mapa__subcategoryBtn--active');
                });

                event.target.classList.add('block-visitgzm-mapa__subcategoryBtn--active');

                geoJsonLayer.forEach((element) => {
                    map.removeLayer(element);
                });

                allGeoJsons.forEach((element) => {
                    geoJsonLayer.push(L.geoJSON(element, {
                        onEachFeature: onEachMarker,
                        filter: function (geoJsonFeature) {
                            return (geoJsonFeature.properties['category'] === category);
                        },
                        pointToLayer: function (geoJsonFeature, latlng) {
                            return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                        },
                        style: getStyle
                    }).addTo(map));
                });

                block.querySelectorAll('.visitObject').forEach((element) => {
                    if (element.getAttribute('data-object-category') != currentCategory) {
                        // console.log(element);
                        element.classList.add('visitObject--hide');
                    } else {
                        element.classList.remove('visitObject--hide');
                    }
                });

                if (!block.querySelector('[data-tab=list]').classList.contains('visitTab--open')) {
                    block.querySelector('.visitTab--open').classList.remove('visitTab--open');
                    block.querySelector('[data-tab=list]').classList.add('visitTab--open');
                }

                parametersInputs = block.querySelectorAll('[data-filter="parameters"]');
                parametersInputs.forEach(parametersInput => {
                    parametersInput.checked = false;
                    parametersInput.removeAttribute('checked');
                });
                
                document.getElementById('filterByName').value = "";
                document.getElementById('filterByGmina').value = "all";
                document.getElementById('filterByGminaFront').value = "all";

                return;
            }

            if (block.querySelector('.block-visitgzm-mapa__sub-category--active [data-subcategory="all"].block-visitgzm-mapa__subcategoryBtn--active')) {
                block.querySelector('.block-visitgzm-mapa__sub-category--active [data-subcategory="all"].block-visitgzm-mapa__subcategoryBtn--active').classList.remove('block-visitgzm-mapa__subcategoryBtn--active');
            }

            if (event.target.classList.contains('block-visitgzm-mapa__subcategoryBtn--active')) {
                event.target.classList.remove('block-visitgzm-mapa__subcategoryBtn--active');
            } else {
                event.target.classList.add('block-visitgzm-mapa__subcategoryBtn--active');
            }

            let selectedSubCategories = [];
            document.querySelectorAll('.block-visitgzm-mapa__sub-category--active .block-visitgzm-mapa__subcategoryBtn--active').forEach(selectedSubCategory => {
                selectedSubCategories.push(selectedSubCategory.getAttribute('data-subcategory'))
            });

            geoJsonLayer.forEach((element) => {
                map.removeLayer(element);
            });

            console.log(`selectedSubCategories.length: ${selectedSubCategories.length}`);
            if(selectedSubCategories.length > 0){

                block.querySelectorAll('.visitObject').forEach((element) => {
                    if (element.getAttribute('data-object-category') != currentCategory) {
                        // console.log(element);
                        element.classList.add('visitObject--hide');
                    } else {
                        if (!selectedSubCategories.includes(element.getAttribute('data-object-subcategory'))) {
                            element.classList.add('visitObject--hide');
                        } else {
                            element.classList.remove('visitObject--hide');
                        }
    
                    }
                });

                allGeoJsons.forEach((element) => {
                    geoJsonLayer.push(L.geoJSON(element, {
                        onEachFeature: onEachMarker,
                        filter: function (geoJsonFeature) {
                            return (geoJsonFeature.properties['category'] === category && selectedSubCategories.includes(geoJsonFeature.properties['subcategory']));
                        },
                        pointToLayer: function (geoJsonFeature, latlng) {
                            return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                        },
                        style: getStyle
                    }).addTo(map));
                });

            } else {



                if (document.querySelector('.block-visitgzm-mapa__sub-category--active [data-subcategory="all"]')) {
                    document.querySelector('.block-visitgzm-mapa__sub-category--active [data-subcategory="all"]').classList.add('block-visitgzm-mapa__subcategoryBtn--active');
                }

                allGeoJsons.forEach((element) => {
                    geoJsonLayer.push(L.geoJSON(element, {
                        onEachFeature: onEachMarker,
                        filter: function (geoJsonFeature) {
                            return (geoJsonFeature.properties['category'] === category);
                        },
                        pointToLayer: function (geoJsonFeature, latlng) {
                            return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                        },
                        style: getStyle
                    }).addTo(map));
                });

            }


            parametersInputs = block.querySelectorAll('[data-filter="parameters"]');
            parametersInputs.forEach(parametersInput => {
                parametersInput.checked = false;
                parametersInput.removeAttribute('checked');
            });
            
            document.getElementById('filterByName').value = "";
            document.getElementById('filterByGmina').value = "all";
            document.getElementById('filterByGminaFront').value = "all";

            let url = new URL(location.href);
            let params = new URLSearchParams(url.search);
            params.set("category", category);
            params.delete("object");
            history.replaceState(
                null, '', location.origin + location.pathname  + '?' + params.toString()
            );

        }

        function changeCategory(event) {
            event.stopPropagation();


            if (event.target.classList.contains('block-visitgzm-mapa__categoryBtn--active') || event.target.closest('[data-category]').classList.contains('block-visitgzm-mapa__categoryBtn--active')) {
                // console.log('kliknieto aktywnego');
                return;
            }
            block.querySelector('.block-visitgzm-mapa__categoryBtn--active').classList.remove('block-visitgzm-mapa__categoryBtn--active');

            if (event.target != this) {
                currentCategory = event.target.closest('[data-category]').getAttribute('data-category');
                event.target.closest('[data-category]').classList.add('block-visitgzm-mapa__categoryBtn--active');
                // console.log(event.target.closest('[data-category]').classList);
            } else {
                currentCategory = event.target.getAttribute('data-category');
                event.target.classList.add('block-visitgzm-mapa__categoryBtn--active');
                // console.log(event.target.classList);
            }

            block.querySelector('.block-visitgzm-mapa__sub-category--active').classList.remove('block-visitgzm-mapa__sub-category--active');
            block.querySelectorAll('[data-category-subcategories=' + currentCategory + '] .block-visitgzm-mapa__subcategoryBtn--active').forEach( ( element ) => {
                element.classList.remove('block-visitgzm-mapa__subcategoryBtn--active')
            } );
            block.querySelector('[data-category-subcategories=' + currentCategory + ']').classList.add('block-visitgzm-mapa__sub-category--active');
            block.querySelector('[data-category-subcategories=' + currentCategory + '] [data-subcategory="all"]').classList.add('block-visitgzm-mapa__subcategoryBtn--active');
            block.querySelector('[data-tab="details"]').classList.remove('visitTab--open');
            block.querySelector('[data-tab="info"]').classList.remove('visitTab--open');
            block.querySelector('[data-tab="list"]').classList.add('visitTab--open');

            if (block.querySelector('.c-visit-details--show')) {
                block.querySelector('.c-visit-details--show').classList.remove('c-visit-details--show');
            }


            geoJsonLayer.forEach((element) => {
                map.removeLayer(element);
            });

            block.querySelectorAll('.visitObject').forEach((element) => {
                if (element.getAttribute('data-object-category') != currentCategory) {
                    // console.log(element);
                    element.classList.add('visitObject--hide');
                } else {
                    element.classList.remove('visitObject--hide');
                }
            });

            allGeoJsons.forEach((element) => {
                geoJsonLayer.push(L.geoJSON(element, {
                    onEachFeature: onEachMarker,
                    filter: function (geoJsonFeature) {
                        return (geoJsonFeature.properties['category'] === currentCategory);
                    },
                    pointToLayer: function (geoJsonFeature, latlng) {
                        return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                    },
                    style: getStyle
                }).addTo(map));
            });

            if (!block.querySelector('[data-tab=list]').classList.contains('visitTab--open')) {
                block.querySelector('.visitTab--open').classList.remove('visitTab--open');
                block.querySelector('[data-tab=list]').classList.add('visitTab--open');
            }

            let parametersInputs = block.querySelectorAll('[data-filter="parameters"]');
            parametersInputs.forEach(parametersInput => {
                parametersInput.checked = false;
                parametersInput.removeAttribute('checked');
            });

            document.getElementById('filterByName').value = "";
            document.getElementById('filterByGmina').value = "all";
            document.getElementById('filterByGminaFront').value = "all";

            // let url = new URL("https://example.com?foo=1&bar=2");
            let url = new URL(location.href);
            let params = new URLSearchParams(url.search);
            params.set("category", currentCategory);
            params.delete("object");
            history.replaceState(
                null, '', location.origin + location.pathname  + '?' + params.toString()
            );

        }


        /**
         *
         * @param {string} layers
         * @param {boolean} status
         */
        function updateLayer(layers, status) {
            if (status) {
                layers.forEach(layer => {
                    let layerName = layer.split('|')[0];
                    let paneName = layer.split('|')[1] ? layer.split('|')[1] : 'wms';
                    let obj = L.tileLayer.wms("https://infogzm.metropoliagzm.pl//iframes/tiles/get_tile.php?", {
                        layers: layerName,
                        format: "image/png",
                        transparent: true,
                        maxZoom: 20,
                        tileSize: 256,
                        pane: paneName
                    });


                    // console.log(paneName);
                    // console.log(layerName);
                    // console.log(obj);
                    // console.log(obj._leaflet_id);
                    // console.log(map);
                    // console.log(layerName);

                    // activeLayers.set(layerName, obj._leaflet_id);
                    // console.log(activeLayers);

                    map.addLayer(obj);
                    activeLayers.set(layerName, obj._leaflet_id);
                });
            } else {
                layers.forEach(layer => {
                    let layerName = layer.split('|')[0];
                    let toRemove;
                    map.eachLayer(function (el) {
                        if (el._leaflet_id == activeLayers.get(layerName)) {
                            toRemove = el;
                        }
                    });
                    if (toRemove) {
                        map.removeLayer(toRemove);
                        activeLayers.delete(layerName)
                    }
                });
            }
        }

        function changeView(event) {
            let selectedView = '';
            if (this != event.target) {
                selectedView = event.target.closest('.visitSidebar__btn').getAttribute('data-view');

            } else {
                selectedView = event.target.getAttribute('data-view');
            }

            if (block.querySelector('[data-tab=' + selectedView + ']').classList.contains('visitTab--open')) {
                return;
            }

            block.querySelector('.visitTab--open').classList.remove('visitTab--open');

            block.querySelector('[data-tab=' + selectedView + ']').classList.add('visitTab--open')


        }

        function filterMap() {
            let filters = [];

            let selectedSubCategories = [];
            document.querySelectorAll('.block-visitgzm-mapa__sub-category--active .block-visitgzm-mapa__subcategoryBtn--active').forEach(selectedSubCategory => {
                selectedSubCategories.push(selectedSubCategory.getAttribute('data-subcategory'))
            });

            let selectedType = document.querySelector('[name="filter"]:checked').value;
            selectedCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
            let selectedFilters = block.querySelectorAll('[data-filter="' + selectedType + '"][type="radio"]');

            console.log(selectedFilters);

            selectedFilters.forEach(selectedFilter => {
                if (selectedFilter.checked) {
                    filters[selectedFilter.getAttribute('name')] = selectedFilter.value;
                }
            });


            geoJsonLayer.forEach((element) => {
                map.removeLayer(element);
            });

            console.log(selectedSubCategories);
            console.log(selectedSubCategories.includes('all'));
            console.log(allGeoJsons);
            
            let idsToShowInSidebar = [];
            
            allGeoJsons.forEach((element) => {
                geoJsonLayer.push(L.geoJSON(element, {
                    onEachFeature: onEachMarker,
                    filter: (geoJsonFeature) => {
                        // let show = true;
                        console.log(geoJsonFeature.properties['title']);
                        console.log(geoJsonFeature.properties['subcategory']);
                        console.log( !selectedSubCategories.includes(geoJsonFeature.properties['subcategory'] ) );
                        console.log( ( !selectedSubCategories.includes('all') && !selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ) );
                        console.log( geoJsonFeature.properties['category'] != selectedCategory );
                        if ( geoJsonFeature.properties['category'] != selectedCategory  ) {
                            return false;
                        }
                        if ( !selectedSubCategories.includes('all') && !selectedSubCategories.includes( geoJsonFeature.properties['subcategory'] ) ) {
                            return false;
                        }
                        // console.log(geoJsonFeature.properties.filtres);
                        // console.log(geoJsonFeature.properties['filtres']);
                        // geoJsonFeature.properties['filter'].forEach(element => {
                        //     console.log(element);
                        // });

                        for (const [key, value] of Object.entries(filters)) {
                            // console.log(`key: ${key} - value: ${value}`);
                            // console.log(`${geoJsonFeature.properties['filtresLogic']}`);
                            // console.log(`${geoJsonFeature.properties['filtresLogic'][key]}`);
                            if (geoJsonFeature.properties['filtresLogic'][key] != value) {
                                // console.log(`${geoJsonFeature.properties['filtresLogic'][key]} != ${value}`);
                                // console.log('nie zgodnosc');
                                return false;
                            } else {
                                // console.log(`${geoJsonFeature.properties['filtresLogic'][key]} == ${value}`);
                                // console.log('zgodnosc');
                            }
                        }
                        // filters.forEach( (value, index) => {
                        //     console.log(`${index}: ${value}`);
                        //     console.log(`${geoJsonFeature.properties['filter'][index]}`);
                        //     if(geoJsonFeature.properties['filter'][index] != value){
                        //         return false;
                        //     }
                        // });
                        // if (geoJsonFeature.properties['category'] != selectedCategory ){
                        //     return false;
                        // }
                        idsToShowInSidebar.push(geoJsonFeature.properties['id']);
                        return true;
                    },
                    pointToLayer: function (geoJsonFeature, latlng) {
                        return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                    },
                    style: getStyle
                }).addTo(map));
            });
            // console.log(idsToShowInSidebar);
            filterSidebarByIDs(idsToShowInSidebar);
        }


        /**
         * Filter sidebar elements by IDs Array
         * @param {array} ids
         */
        function filterSidebarByIDs(ids){
            const currentCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
            const objects = block.querySelectorAll('.visitObject');
            objects.forEach( (element) => {
                if( !ids.includes(parseInt(element.getAttribute('data-object-id'))) ){
                    element.classList.add('visitObject--hide');
                } else {
                    element.classList.remove('visitObject--hide');
                }
            });
        }


        function switchFilters(element) {
            // console.log(element);

            // let group = element.closest('.control__subgroup');
            // group.classList.add('control__subgroup--active');

            let elementsToUnblock = block.querySelectorAll('[data-filter="' + element + '"]');
            // console.log('elementsToUnblock');
            // console.log(elementsToUnblock);
            elementsToUnblock.forEach(elementToUnblock => {
                elementToUnblock.removeAttribute('disabled');
            });

            let elementsToBlock = block.querySelectorAll('[data-filter]:not([data-filter="' + element + '"])');
            // console.log('elementsToBlock');
            // console.log(elementsToBlock);
            elementsToBlock.forEach(elementToBlock => {
                elementToBlock.setAttribute('disabled', true);
            });

            let elementsToNotOpacity = block.querySelectorAll('[data-opacity]:not([data-opacity="' + element + '"])');
            elementsToNotOpacity.forEach(element => {
                element.classList.add('control__row--opacity');
            });
            let elementsToOpacity = block.querySelectorAll('[data-opacity="' + element + '"]');
            elementsToOpacity.forEach(element => {
                element.classList.remove('control__row--opacity');
            });

            parametersInputs = block.querySelectorAll('[data-filter="parameters"]');
            parametersInputs.forEach(parametersInput => {
                parametersInput.checked = false;
                parametersInput.removeAttribute('checked');
            });
            
            document.getElementById('filterByName').value = "";
            document.getElementById('filterByGmina').value = "all";
            document.getElementById('filterByGminaFront').value = "all";

            filterMap();

        }

        function showDetails(element) {

            currentScroll = block.querySelector('.block-visitgzm-mapa__sidebar .visitSidebar__inner').scrollTop;
            
            let id = 0;
            if (element != this) {
                id = element.closest('[data-object-id]').getAttribute('data-object-id');
            } else {
                id = element.getAttribute('data-object-id');
            }
            block.querySelector('[data-details-id="' + id + '"]').classList.add('c-visit-details--show');
            // block.querySelector('[data-tab]').classList.remove('visitTab--open');
            block.querySelectorAll('[data-tab]').forEach((element) => {
                element.classList.remove('visitTab--open')
            });
            block.querySelector('[data-tab="details"]').classList.add('visitTab--open');
            block.querySelector('.block-visitgzm-mapa__sidebar .visitSidebar__inner').scrollTop = 0;

            let iconUrl;
            let primaryColor;
            let secondaryColor;
            let primaryColorActive;
            let secondaryColorActive;

            if (highlightedMarker !== null) {

                iconUrl = styleData[highlightedMarker.feature.properties['subcategory']]['point']['icon'];
                primaryColor = '--primarycolor: ' + styleData[highlightedMarker.feature.properties['subcategory']]['primaryColor'] + '; ';
                secondaryColor = '--secondarycolor: ' + styleData[highlightedMarker.feature.properties['subcategory']]['secondaryColor'] + '; ';
                primaryColorActive = '--primarycoloractive: ' + styleData[highlightedMarker.feature.properties['subcategory']]['primaryColorActive'] + '; ';
                secondaryColorActive = '--secondarycoloractive: ' + styleData[highlightedMarker.feature.properties['subcategory']]['secondaryColorActive'] + '; ';
            
                highlightedMarker.setIcon(
                    L.divIcon({
                        iconSize: new L.Point(26, 26),
                        iconAnchor: new L.Point(13, 13),
                        className: 'visitgzm-marker visitgzm-marker--highlighted',
                        html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + ' z-index:999999;" ><img src="' + iconUrl + '" /></span>'
                    })
                );
                highlightedMarker = null;
            }

            let coordinatesHighlightetMarker;
            let coordinatesHighlightetBounds;
            map.eachLayer(function (layer) { 
                if('feature' in layer){
                    if('properties' in layer.feature){
                        if( layer.feature.properties.id !== undefined && layer.feature.properties.title !== undefined ){
                            console.log(layer.feature.properties.id);
                            console.log(layer.feature.properties.title);

                            if(layer.feature.properties.id == id){
                                // console.log(e.target.feature.properties.id);
                                if(layer.feature.properties.type == 'point'){
                                    
                                    iconUrl = styleData[layer.feature.properties['subcategory']]['point']['icon'];
                                    primaryColor = '--primarycolor: ' + styleData[layer.feature.properties['subcategory']]['primaryColor'] + '; ';
                                    secondaryColor = '--secondarycolor: ' + styleData[layer.feature.properties['subcategory']]['secondaryColor'] + '; ';
                                    primaryColorActive = '--primarycoloractive: ' + styleData[layer.feature.properties['subcategory']]['primaryColorActive'] + '; ';
                                    secondaryColorActive = '--secondarycoloractive: ' + styleData[layer.feature.properties['subcategory']]['secondaryColorActive'] + '; ';
                                    
                                    layer.setIcon(
                                        L.divIcon({
                                            iconSize: new L.Point(40, 40),
                                            iconAnchor: new L.Point(20, 20),
                                            className: 'visitgzm-marker visitgzm-marker--highlighted',
                                            html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + '" ><img src="' + iconUrl + '" /></span>'
                                        })
                                    );
                                    highlightedMarker = layer;
                                    coordinatesHighlightetMarker = layer.getLatLng(); 

                                } else {
                                    // console.log(layer);
                                    coordinatesHighlightetMarker = layer.getCenter(); 
                                }
                            }

        
                        }
                    }
                }
            });

            // console.log(`coordinatesHighlightetMarker: ${coordinatesHighlightetMarker}`);
            if(coordinatesHighlightetMarker){
                // console.log('flyTo');
                map.flyTo(coordinatesHighlightetMarker, 14, {   
                    animate: true,  
                    duration: 0.3 
                });
            }

            // if(coordinatesHighlightetBounds){
            //     map.flyToBounds(coordinatesHighlightetBounds, 14, {   
            //         animate: true,  
            //         duration: 0.3 
            //     });
            // }

            let currentCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
            let url = new URL(location.href);
            let params = new URLSearchParams(url.search);
            params.set("category", currentCategory);
            params.set("object", id);
            history.replaceState(
                null, '', location.origin + location.pathname  + '?' + params.toString()
            );

            
        }

        function resetMap() {

            let parametersInputs = block.querySelectorAll('[data-filter="parameters"]');
            parametersInputs.forEach(parametersInput => {
                parametersInput.checked = false;
                parametersInput.removeAttribute('checked');
            });

            filterMap();
        }

        const closeSidebarDetailsBtns = block.querySelectorAll('.c-visit-details__close');
        closeSidebarDetailsBtns.forEach(closeSidebarDetailsBtn => {
            closeSidebarDetailsBtn.addEventListener('click', (event) => {
                event.target.closest('.c-visit-details--show').classList.remove('c-visit-details--show');
                block.querySelector('[data-tab="details"]').classList.remove('visitTab--open');
                block.querySelector('[data-tab="list"]').classList.add('visitTab--open');
                if(window.innerWidth < 768){
                    block.querySelector('.block-visitgzm-mapa__sidebar').classList.remove('active');
                }

                if (highlightedMarker !== null) {

                    let iconUrl = styleData[highlightedMarker.feature.properties['subcategory']]['point']['icon'];
                    let primaryColor = '--primarycolor: ' + styleData[highlightedMarker.feature.properties['subcategory']]['primaryColor'] + '; ';
                    let secondaryColor = '--secondarycolor: ' + styleData[highlightedMarker.feature.properties['subcategory']]['secondaryColor'] + '; ';
                    let primaryColorActive = '--primarycoloractive: ' + styleData[highlightedMarker.feature.properties['subcategory']]['primaryColorActive'] + '; ';
                    let secondaryColorActive = '--secondarycoloractive: ' + styleData[highlightedMarker.feature.properties['subcategory']]['secondaryColorActive'] + '; ';
                
                    highlightedMarker.setIcon(
                        L.divIcon({
                            iconSize: new L.Point(26, 26),
                            iconAnchor: new L.Point(13, 13),
                            className: 'visitgzm-marker',
                            html: '<span style="' + primaryColor + secondaryColor + primaryColorActive + secondaryColorActive + '" ><img src="' + iconUrl + '" /></span>'
                        })
                    );
                    highlightedMarker = null;
                }
                block.querySelector('.block-visitgzm-mapa__sidebar .visitSidebar__inner').scrollTop = currentScroll;


                let currentCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
                let url = new URL(location.href);
                let params = new URLSearchParams(url.search);
                params.set("category", currentCategory);
                params.delete("object");
                history.replaceState(
                    null, '', location.origin + location.pathname  + '?' + params.toString()
                );

            });
        });


        const singlePosts = block.querySelectorAll('[data-object-id]');
        singlePosts.forEach(singlePosts => {
            singlePosts.addEventListener('click', (event) => {
                showDetails(event.target);
            });
        });

        const filterByAttrBtn = document.getElementById(block.id + '_filterBtn');
        filterByAttrBtn.addEventListener('click', filterMap);

        const filterSwitcher = document.getElementsByName('filter');
        filterSwitcher.forEach(filterSwitch => {
            filterSwitch.addEventListener('change', (event) => {
                switchFilters(event.target.value);
            });
        });

        const resetAttrBtn = document.getElementById(block.id + '_resetBtn');
        resetAttrBtn.addEventListener('click', resetMap);

        let categoryBtns = document.querySelectorAll('.block-visitgzm-mapa__categoryBtn');
        categoryBtns.forEach(categoryBtn => {
            categoryBtn.addEventListener('click', changeCategory);
        });

        let subcategoryBtns = document.querySelectorAll('.block-visitgzm-mapa__subcategoryBtn');
        subcategoryBtns.forEach(subcategoryBtn => {
            subcategoryBtn.addEventListener('click', filterMarkersBySubcategory);
        });

        const viewBtns = document.querySelectorAll('.visitSidebar__btn');
        viewBtns.forEach(viewBtn => {
            viewBtn.addEventListener('click', changeView);
        });

        

        const controlPanels = document.querySelectorAll('.control__open');
        controlPanels.forEach(controlPanel => {
            controlPanel.addEventListener('click', (event) => {

                let restGroups = document.querySelectorAll('.control__group--open');
                console.log(restGroups);
                restGroups.forEach((group) => {
                    console.log(group);
                    if (!group.classList.contains('control__group--dock')) {
                        group.classList.remove('control__group--open');
                        group.querySelector('.control__wrapper').classList.remove('control__wrapper--opened');
                        // group.querySelector('.control__wrapper').style.maxHeight = 0;
                    }
                });

                event.target.parentElement.classList.add('control__group--open');
                let wrapper = event.target.parentElement.querySelector('.control__wrapper');
                // wrapper.style.maxHeight = wrapper.scrollHeight + 10 + "px";
                wrapper.classList.add('control__wrapper--opened');
            });
        });


        const minimizePanels = document.querySelectorAll('.js-controlMinimize');
        minimizePanels.forEach(minimizePanel => {
            minimizePanel.addEventListener('click', (event) => {
                let openedPanel = event.target.closest('.control__group');
                openedPanel.classList.remove('control__group--open');
                openedPanel.querySelector('.control__wrapper').classList.remove('control__wrapper--opened');
                // openedPanel.querySelector('.control__wrapper').style.maxHeight = 0;
            });
        });

        const filterByGminaSelect = document.getElementById('filterByGmina');
        const filterByGminaFrontSelect = document.getElementById('filterByGminaFront');
        filterByGminaSelect.addEventListener('change', filterByGmina);
        filterByGminaFrontSelect.addEventListener('change', filterByGmina);

        function filterByGmina( event ){

            let idsToShowInSidebar = [];
            let serachPhrase = event.target.value;
            if(event.target.id === 'filterByGminaFront' ){
                filterByGminaSelect.value = serachPhrase;
            } else {
                filterByGminaFrontSelect.value = serachPhrase;

            }

            if( serachPhrase == 'all'){

                let category = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
                let selectedSubCategories = [];
                document.querySelectorAll('.block-visitgzm-mapa__sub-category--active .block-visitgzm-mapa__subcategoryBtn--active').forEach(selectedSubCategory => {
                    if(selectedSubCategory.getAttribute('data-subcategory') != 'all'){
                        selectedSubCategories.push(selectedSubCategory.getAttribute('data-subcategory'));
                    }
                });
    
                
                geoJsonLayer.forEach((element) => {
                    map.removeLayer(element);
                });
    
    
                allGeoJsons.forEach((element) => {
                    geoJsonLayer.push(L.geoJSON(element, {
                        onEachFeature: onEachMarker,
                        filter: (geoJsonFeature) => {
                            if( geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ) ){
                                idsToShowInSidebar.push(geoJsonFeature.properties['id']);
                                return true;
                            }
                            // return ( geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ));
                        },
                        pointToLayer: function (geoJsonFeature, latlng) {
                            return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                        },
                        style: getStyle
                    }).addTo(map));
                });



            } else {

                let category = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
                let selectedSubCategories = [];
                document.querySelectorAll('.block-visitgzm-mapa__sub-category--active .block-visitgzm-mapa__subcategoryBtn--active').forEach(selectedSubCategory => {
                    if(selectedSubCategory.getAttribute('data-subcategory') != 'all'){
                        selectedSubCategories.push(selectedSubCategory.getAttribute('data-subcategory'));
                    }
                });
                
                geoJsonLayer.forEach((element) => {
                    map.removeLayer(element);
                });
    
    
                allGeoJsons.forEach((element) => {
                    geoJsonLayer.push(L.geoJSON(element, {
                        onEachFeature: onEachMarker,
                        filter: (geoJsonFeature) => {
                            console.log(serachPhrase);
                            console.log(geoJsonFeature.properties['gmina']);
                            console.log(geoJsonFeature.properties['gmina'].includes(serachPhrase));
                            if( geoJsonFeature.properties['gmina'].includes(serachPhrase) && geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ) ){
                                idsToShowInSidebar.push(geoJsonFeature.properties['id']);
                                return true;
                            }
                            // return (geoJsonFeature.properties['gmina'] == serachPhrase && geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ));
                        },
                        pointToLayer: function (geoJsonFeature, latlng) {
                            return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                        },
                        style: getStyle
                    }).addTo(map));
                });
            }

            filterSidebarByIDs(idsToShowInSidebar);

            

        }


        const filterByNameInput = document.getElementById('filterByName');
        filterByNameInput.addEventListener('input', startTimerFilterByName);

        function startTimerFilterByName( event ){
            console.log(event.target.value);
            if ( timer !== undefined ) {
 
                clearTimeout( timer );
         
            }
            timer = setTimeout( filterByName, 500, event.target );
        }

        function filterByName( element  ){

            let serachPhrase = element.value;

            if ( element.value.length >= 3 ) {

                console.log('filterByName');
                
                clearTimeout( timer );

                let category = block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category');
                let selectedSubCategories = [];
                document.querySelectorAll('.block-visitgzm-mapa__sub-category--active .block-visitgzm-mapa__subcategoryBtn--active').forEach(selectedSubCategory => {
                    if(selectedSubCategory.getAttribute('data-subcategory') != 'all'){
                        selectedSubCategories.push(selectedSubCategory.getAttribute('data-subcategory'));
                    }
                });

                // console.log(category);
                // console.log(selectedSubCategories);
                // console.log(element.value);
                // console.log(typeof element.value);
                
                geoJsonLayer.forEach((element) => {
                    map.removeLayer(element);
                });

                let idsToShowInSidebar = [];


                allGeoJsons.forEach((element) => {
                    geoJsonLayer.push(L.geoJSON(element, {
                        onEachFeature: onEachMarker,
                        filter: (geoJsonFeature) => {
                            console.log(geoJsonFeature.properties['title']);
                            console.log(geoJsonFeature.properties['title'].toLowerCase().includes(serachPhrase) );
                            console.log(geoJsonFeature.properties['category'] === category );
                            console.log( (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ));
                            console.log(geoJsonFeature.properties['title'].toLowerCase().includes(serachPhrase) && geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ));
                            // return (geoJsonFeature.properties['title'].toLowerCase().includes(serachPhrase) && geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ));
                            if( geoJsonFeature.properties['title'].toLowerCase().includes(serachPhrase) && geoJsonFeature.properties['category'] === category && (  selectedSubCategories.length == 0 || selectedSubCategories.includes(geoJsonFeature.properties['subcategory']) ) ){
                                idsToShowInSidebar.push(geoJsonFeature.properties['id']);
                                return true;

                            }
                        },
                        pointToLayer: function (geoJsonFeature, latlng) {
                            return L.marker(latlng, {icon: getPoint(geoJsonFeature)});
                        },
                        style: getStyle
                    }).addTo(map));
                });
                filterSidebarByIDs(idsToShowInSidebar);

            }


        }

        
        function getCurentMapBackground(){
            if( !block.querySelector('input[name=mapBG]:checked') ){
                return;
            }
            const curentMapBackgroundChecked = block.querySelector('input[name=mapBG]:checked').value;
            console.log(curentMapBackgroundChecked);
            let tempMapBG = mapBackgrounds[curentMapBackgroundChecked];

            // mapBackgrounds->curentMapBackgroundChecked

            let mapBackground = L.tileLayer(tempMapBG.url, {
                attribution: tempMapBG.attribution ? tempMapBG.attribution : '',
                //	className: 'carto',
                subdomains: tempMapBG.subdomains ? tempMapBG.subdomains : ''
            });
            return mapBackground;
        }

        const mapBackgroundSwitchers = document.getElementsByName('mapBG');
        mapBackgroundSwitchers.forEach(mapBackgroundSwitcher => {
            mapBackgroundSwitcher.addEventListener('change', (event) => {
                switchMapBackground(event.target.value);
            });
        });


        function switchMapBackground(mapBg) {
            map.removeLayer(curentMapBackground);

            let tempMapBG = mapBackgrounds[mapBg];

            let mapBackground = L.tileLayer(tempMapBG.url, {
                attribution: tempMapBG.attribution ? tempMapBG.attribution : '',
                className: tempMapBG.id ? tempMapBG.id : '',
                subdomains: tempMapBG.subdomains ? tempMapBG.subdomains : ''
            });
            map.addLayer(mapBackground);

            if(tempMapBG.borderColor == 'black'){
                gzm.resetStyle();
                wojThin.resetStyle();
            } else {
                gzm.setStyle({
                    color: "#FFF"
                });
                wojThin.setStyle({
                    color: "#FFF"
                });
            }
            
            if(tempMapBG.labels == 'on'){
                updateLayer(['gzm:Tereny_gm_labels|woj'], true);
            } else {
                updateLayer(['gzm:Tereny_gm_labels|woj'], false);
            }


            // console.log(mapBg);
            // if (mapBg == 'CartoDb') {
            //     map.removeLayer(GoogleSatellite);
            //     map.addLayer(CartoDb);
            //     gzm.resetStyle();
            //     wojThin.resetStyle();
            //     // document.getElementsByName('gzm:Tereny_gm_labels|woj')[0].checked = true;
            //     updateLayer(['gzm:Tereny_gm_labels|woj'], true);
            // } else {
            //     map.addLayer(GoogleSatellite);
            //     map.removeLayer(CartoDb);
            //     // document.getElementsByName('gzm:Tereny_gm_labels|woj')[0].checked = false;
            //     updateLayer(['gzm:Tereny_gm_labels|woj'], false);
            //     gzm.setStyle({
            //         color: "#FFF"
            //     });
            //     wojThin.setStyle({
            //         color: "#FFF"
            //     });
            // }
        }

        const radioButtonChangers = block.querySelectorAll('[data-change-radio]');
        radioButtonChangers.forEach(radioButtonChanger => {
            radioButtonChanger.addEventListener('change', (event) => {
                changeRadioButton(event);
            });
        });

        function changeRadioButton( ev ){
            let target = ev.target.getAttribute('data-change-radio').split('|')[0];
            let ifSelected = ev.target.getAttribute('data-change-radio').split('|')[1];
            let ifNotSelected = ev.target.getAttribute('data-change-radio').split('|')[2];

            console.log(target);
            console.log(ifSelected);
            console.log(ifNotSelected);

            block.querySelectorAll('[name="'+target+'"]').forEach( (radio) => {
                console.log(`${ev.target.checked} - ${radio.value} - ${ifSelected}`);
                if(ev.target.checked && radio.value == ifSelected){
                    console.log(`${radio} is selected`);

                    radio.setAttribute('checked', '');
                    radio.checked = true;
                } else {
                    console.log(`${radio} is unselected`);

                    radio.checked = false;
                    radio.removeAttribute('checked');
                }
            });

        }


        changeMapByURL();
        function changeMapByURL(){

            let params = new URLSearchParams(document.location.search);
            let category = params.get("category");
            let object = params.get("object");

            const event = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: true,
            });

            if(category){
                let categoryBtn = block.querySelector('[data-category="'+category+'"]');
                categoryBtn.dispatchEvent(event);
            } else {
                let currentCategory = block.querySelector('.block-visitgzm-mapa__categoryBtn--active') ? block.querySelector('.block-visitgzm-mapa__categoryBtn--active').getAttribute('data-category') : '';
                let url = new URL(location.href);
                let params = new URLSearchParams(url.search);
                params.set("category", currentCategory);
                history.replaceState(
                    null, '', location.origin + location.pathname  + '?' + params.toString()
                );
            }


            if(object){
                let objectDetailsElement = block.querySelector('[data-object-id="'+object+'"]');
                objectDetailsElement.dispatchEvent(event);
            }

        }

        let layerSelectors = block.querySelectorAll('[name^="gzm:"]');
        layerSelectors.forEach(layerSelector => {
            layerSelector.addEventListener('change', changeLayerStatus);
            // if (layerSelector.checked) {
            //     updateAdditionalLayer(layerSelector, true);
            // }
        });

        /**
         * Changing visibility of addicional layers on map
         * @param {event} event
         */
        function changeLayerStatus(event) {
            let status = event.target.checked;
            let layer = event.target.getAttribute('data-layer');
            let url = event.target.getAttribute('data-url');
            updateAdditionalLayer(url, layer, status);
        }

        function updateAdditionalLayer(url, layer, status){
            if (status) {
                
                let paneName = 'wms';
                let obj = L.tileLayer.betterWms(url, {
                    layers: layer,
                    format: "image/png",
                    transparent: true,
                    maxZoom: 20,
                    tileSize: 256,
                    pane: paneName
                });

                map.addLayer(obj);
                activeLayers.set(layer, obj._leaflet_id);
                
            } else {
                
                let toRemove;
                map.eachLayer(function (el) {
                    if (el._leaflet_id == activeLayers.get(layer)) {
                        toRemove = el;
                    }
                });
                if (toRemove) {
                    map.removeLayer(toRemove);
                    activeLayers.delete(layer)
                }
            }
        }

        
        const autoOpenPanel = block.querySelector('.js-auto-open-desktop');
        if(autoOpenPanel && window.innerWidth >= 768){
            autoOpenPanel.classList.add('control__group--open');
            autoOpenPanel.querySelector('.control__wrapper').classList.add('control__wrapper--opened');
        }


    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if (blocks.length > 0) {
            blocks.forEach((block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();